import axios from 'axios'
// eslint-disable-next-line import/no-internal-modules
import { Filters } from '@insided/deprecated-control/overview'
// eslint-disable-next-line import/no-internal-modules
import { CustomProfileFieldList } from '@insided/deprecated-control/UserOverview/Columns'
// eslint-disable-next-line import/no-internal-modules
import { getFilterParams } from '@insided/deprecated-control/UserOverview/Filters'
import { getInsidedData } from '@insided/destination/utils/insidedDataStorage'

export const deleteSegment = async (id: number) => {
  const user = getInsidedData('user')

  return await axios.delete(`/users/segments/${id}?userId=${user.userid}`)
}

export const updateSegment = async (
  id: number,
  title: string,
  description: string,
  filters: Filters,
  customProfileFields: CustomProfileFieldList
) => {
  const user = getInsidedData('user')
  const payload = {
    title,
    description,
    filters: getFilterParams(filters, customProfileFields)
  }

  return await axios.put(`/users/segments/${id}?userId=${user.userid}`, payload)
}
